import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { NHAActionBarComponent } from './action-bar.component';
import { MatButtonModule } from '@angular/material/button';
import { NHAAnimationDirectivesModule } from '../animations/nha-animation-directives.module';

@NgModule({
	imports: [CommonModule, MatIconModule, MatButtonModule, NHAAnimationDirectivesModule, NHAActionBarComponent],
	exports: [NHAActionBarComponent]
})
export class NHAActionBarModule {}
